// @ts-nocheck
import {
    availabilityStyles,
    ProductDetailsAvailabilityStyles,
} from "@insite/content-library/Widgets/ProductDetails/ProductDetailsAvailability";
import { ProductAvailabilityStyles } from "@store/Overrides/Components/ProductAvailability";

type Styles = ProductDetailsAvailabilityStyles & {
    availability?: ProductAvailabilityStyles;
};

Object.assign<Styles>(availabilityStyles, {});
